'use strict';/* global define */define('modules/core/modules/app/services/http-pending-requests/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$q", "ng"];
function factory($q,ng){// jshint validthis:true
// jshint latedef:false
var cancelPromises=[];return{newTimeout:newTimeout,cancelAll:cancelAll};// ---
/**
     * Create new timeout promices
     *
     * @return {Object} - promise object
     */function newTimeout(){var cancelPromise=$q.defer();cancelPromises.push(cancelPromise);return cancelPromise.promise;}/**
     * Cancel all stored promises
     */function cancelAll(){ng.forEach(cancelPromises,function(cancelPromise){cancelPromise.promise.isGloballyCancelled=true;cancelPromise.resolve();});cancelPromises.length=0;}}module.exports=factory;});
